import React from 'react';
import { WIDGETS_CONFIG } from '../../data/config';
import GitHubActivity from '../widgets/GitHubActivity';
import NowPlaying from '../widgets/NowPlaying';
import CoffeeTracker from '../widgets/CoffeeTracker';
import CommitStreak from '../widgets/CommitStreak';
import BlogPosts from '../widgets/BlogPosts';
import CodeStatistics from '../widgets/CodeStatistics';
import CurrentLocation from '../widgets/CurrentLocation';

const WIDGET_COMPONENTS = {
  github: GitHubActivity,
  spotify: NowPlaying,
  coffee: CoffeeTracker,
  streak: CommitStreak,
  blog: BlogPosts,
  stats: CodeStatistics,
  location: CurrentLocation,
};

const Widgets = () => {
  const enabledWidgets = WIDGETS_CONFIG
    .filter(w => w.enabled)
    .sort((a, b) => a.order - b.order);

  return (
    <section id="widgets" className="section-container">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 gradient-text">Live Dashboard</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-cream-200 to-cream-300 mx-auto mb-6 rounded-full" style={{ boxShadow: '0 0 20px rgba(255, 232, 200, 0.5)' }}></div>
          <p className="text-cream-200 text-lg max-w-2xl mx-auto" style={{ opacity: 0.9 }}>
            Real-time insights into my development workflow
          </p>
        </div>

        {/* Widgets Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Row 1: Spotify and Coffee (short widgets) */}
          <div className="md:col-span-1">
            <NowPlaying delay={0} />
          </div>
          <div className="md:col-span-1">
            <CoffeeTracker delay={100} />
          </div>
          
          {/* Row 1-2: GitHub Activity (tall, spans 2 rows) */}
          <div className="md:col-span-1 lg:row-span-2">
            <GitHubActivity delay={200} />
          </div>
          
          {/* Row 2: Commit Streak and Location */}
          <div className="md:col-span-1">
            <CommitStreak delay={300} />
          </div>
          <div className="md:col-span-1">
            <CurrentLocation delay={400} />
          </div>
          
          {/* Row 3: Blog Posts (spans 2 columns) */}
          <div className="md:col-span-2 lg:col-span-2">
            <BlogPosts delay={500} />
          </div>
          
          {/* Row 3: Code Statistics */}
          <div className="md:col-span-2 lg:col-span-1">
            <CodeStatistics delay={600} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Widgets;
